import ProtectedRoute from '../ProtectedRoute';
import Confirm from './Confirm';

const ConfirmRoute = () => (
  <ProtectedRoute key="confirm" exact path="/confirm" page={<Confirm />} />
);

export default ConfirmRoute;
